import { createContext, type ReactNode, useContext } from 'react';
import { usePhieuKeToanExport, usePhieuKeToanImport, useSearchFieldStates } from './hooks';

interface PhieuKeToanContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  isImportDialogOpen: boolean;
  openImportDialog: () => void;
  closeImportDialog: () => void;
  searchFieldStates: ReturnType<typeof useSearchFieldStates>;
  isLoadingImport: boolean;
  setIsLoadingImport: (isLoading: boolean) => void;
}

const PhieuKeToanContext = createContext<PhieuKeToanContextValue | null>(null);

export const usePhieuKeToanContext = () => {
  const context = useContext(PhieuKeToanContext);
  if (!context) {
    throw new Error('usePhieuKeToanContext must be used within PhieuKeToanProvider');
  }
  return context;
};

export const PhieuKeToanProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = usePhieuKeToanExport();
  const { isImportDialogOpen, isLoadingImport, openImportDialog, closeImportDialog, setIsLoadingImport } =
    usePhieuKeToanImport();
  const searchFieldStates = useSearchFieldStates();

  return (
    <PhieuKeToanContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        isImportDialogOpen,
        isLoadingImport,
        openImportDialog,
        closeImportDialog,
        setIsLoadingImport,
        searchFieldStates
      }}
    >
      {children}
    </PhieuKeToanContext.Provider>
  );
};
